import ChartsService from '@/services/benchmarks/ChartsService.js';
import { cssVarToHex, getBenchmarkId } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';

export async function fetchEngagementMatrix({ commit, rootState, rootGetters }) {
  try {
    commit(chartsMutationTypes.ENGAGEMENT_MATRIX_LOADING, true);
    commit(chartsMutationTypes.ENGAGEMENT_MATRIX_ERROR_DEFAULT, false);
    commit(chartsMutationTypes.ENGAGEMENT_MATRIX_ERROR_PID_LIMIT, false);

    const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');
    const channelListJoined = rootGetters['benchmarks/channelsLabels'].join(',');
    const channelSelected = rootState.ui.channel;
    const handleChannelSelected = channelSelected === 'Todas' ? channelListJoined : channelSelected;
    const colorList = rootState.benchmarks.colorList;

    const data = await ChartsService.getEngagementMatrix({
      'benchmark-id': getBenchmarkId(),
      'group-id': groupIdListJoined,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      channel: handleChannelSelected,
    });

    const toView = (matrixData) => ({
      data: matrixData.companies,
      metadata: {
        xAxis: {
          maximum: matrixData.metadata?.[0].axesX.maximum,
          minimum: matrixData.metadata?.[0].axesX.minimum,
          middle: matrixData.metadata?.[0].axesX.middle,
        },
        yAxis: {
          maximum: matrixData.metadata?.[0].axesY.maximum,
          minimum: matrixData.metadata?.[0].axesY.minimum,
          middle: matrixData.metadata?.[0].axesY.middle,
        },
      },
    });

    const { data: series, metadata } = toView(data);

    const seriesWithColors = series?.map((items, index) => ({
      ...items,
      color: cssVarToHex(colorList[index].color),
    }));

    const payload = {
      series: seriesWithColors,
      metadata,
    };

    commit(chartsMutationTypes.ENGAGEMENT_MATRIX_DATA, payload);
  } catch (e) {
    if (typeof e === 'string' && e === 'PID limit exceeded') {
      commit(chartsMutationTypes.ENGAGEMENT_MATRIX_ERROR_PID_LIMIT, true);
      console.error(e);
      return e;
    }

    commit(chartsMutationTypes.ENGAGEMENT_MATRIX_ERROR_DEFAULT, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.ENGAGEMENT_MATRIX_LOADING, false);
  }
}
